import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Header from '../../components/Header';
import Filter from '../../components/Filter';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withCaseFilter from '../../common/withCaseFilter';
import withSearchFilter from '../../common/withSearchFilter';
import { onGoBack } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';

class ManageCaseFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      showSearchProducts: false
    };
  }

  _checkValidation = (filterData) => {
    try {
      if (Object.keys(filterData).length) {
        return !!Object.keys(filterData).filter((field) => !!(filterData[field].length || (filterData[field] !== ''))).length;
      } return false;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onApplyFilter = async () => {
    try {
      const { setCaseFilter, notify } = this.props;
      const { filterData } = this.state;

      const { filterData: { selectedStartDate, selectedEndDate } } = this.state;
      if (selectedStartDate !== undefined || selectedEndDate !== undefined) {
        if ((selectedStartDate === '' || selectedStartDate === undefined) && (selectedEndDate !== '')) {
          notify({ type: 'error', message: 'Please select start date' });
          return;
        }
      }
      _.mapKeys(filterData, (value, key) => {
        if (_.isArray(value) && _.isEmpty(value)) delete filterData[key];
      });

      _.mapKeys(filterData, (value, key) => {
        if (_.isString(value) && _.isEmpty(value)) delete filterData[key];
      });

      if (this._checkValidation(filterData)) {
        this._onGoBack();
        setCaseFilter(filterData);
        browserHistory.push('/manage-cases/filter-cases');
      } else {
        notify({ type: 'error', message: 'You must select at least one search field' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      this.setState({ filterData: data });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearFilter = () => {
    try {
      const { setCaseFilter } = this.props;
      this.setState({ filterData: {} });
      setCaseFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _goBack = () => {
    try {
      const {
        goBack, setCaseFilter, setSearchFilter
      } = this.props;
      const { showSearchProducts } = this.state;
      if (showSearchProducts) {
        this.setState({ showSearchProducts: false });
        return;
      }
      setCaseFilter({});
      setSearchFilter({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const { caseFilter } = this.props;
      this.setState({ filterData: caseFilter });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { filterData, showSearchProducts } = this.state;
    const { caseFilter } = this.props;
    return (
      <div className="site-wrapper">
        <Header
          actionButton={showSearchProducts ? undefined : { title: 'Execute', onClick: this._onApplyFilter }}
          title={showSearchProducts ? 'Product' : 'Search Cases'}
          goBack={this._goBack}
        />
        <Filter
          title="Search Cases"
          filter={{
            keywords: true,
            date: true,
            patient: true,
            repNotes: true,
            comments: true,
            surgeonNotes: true,
            poNumber: true
          }}
          previousData={filterData}
          onFilter={(data) => this._onFilter(data)}
          selectedFilter={caseFilter}
          onClearFilter={this._onClearFilter}
          showSearchProducts={showSearchProducts}
          setShowSearchProducts={(value) => this.setState({ showSearchProducts: value })}
        />
      </div>
    );
  }
}

export default withSearchFilter(
  withCaseFilter(
    withNotify(
      withGoBack(
        ManageCaseFilter
      )
    )
  )
);
